import { Box } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { NOT_SELECTABLE } from "../../graphic/theme";

export default function LinkContainer({
  url,
  children,
  blank = true,
  sx = {},
}) {
  if (!url) {
    return children;
  } else {
    return (
      <Box
        sx={{
          textDecoration: "none",
          width: "fit-content",
          height: "fit-content",
          ...NOT_SELECTABLE,
          ...sx,
        }}
        component={Link}
        target={blank ? "_blank" : "_self"}
        to={url}
        href={url}
      >
        {children}
      </Box>
    );
  }
}
